// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2lRtW","list":"PatternAutocomplete_list__1F8_v"};